import {
  Column,
  ContactsState,
  Contact,
  Page,
  Campaign,
  FilterTag,
  FilterTagGroup,
  FiltersEditedItems
} from './shared/models/Contact';
import { createSelector } from 'reselect';
import {
  GET_CONTACTS_SUCCESS,
  GET_COLUMNS_SUCCESS,
  GET_EVENTS,
  GET_EVENTS_SUCCESS,
  ContactsAction,
  HIDE_EVENTS,
  UPDATE_COLUMNS,
  SET_DATE_RANGE,
  CLEAR_FILTER,
  SET_FILTER_TAGS,
  ADD_TAG,
  REMOVE_TAG,
  GET_FILTER_ITEMS_SUCCESS,
  SET_FILTER_ITEMS_OPENED,
  SET_FILTERING_BY_ITEM,
  UPDATE_EDITED_FILTERS_LIST,
  UPDATE_TEMP_PAGE_WITH_ITEMS,
  OPEN_TOOLTIP_TAG_GROUP,
  CLOSE_TOOLTIP_TAG_GROUP,
  CLEAR_TOOLTIP_TAG_GROUP,
  SAVE_CALL_RANGE_FILTER_FORM,
  UPDATE_TEMP_EDITED_FILTERS_LIST,
  CLEAR_EDITED_FILTERS_LIST,
  REVERT_EDITED_FILTER_CHANGES,
  TAKE_EDITING_FILTER_SNAPSHOT,
  UPDATE_TEMP_FILTER_MAXDATA,
  RESET_STATE,
  UPDATE_TEMP_TAG,
  UPDATE_EXPANDED_LIST,
  SET_CALL_FINISH_TYPE_FILTER,
  REMOVE_CALL_FINISH_TYPE_FILTER,
  TAKE_CALL_FINISH_TYPE_SNAPSHOT,
  REVERT_CALL_FINISH_TYPE_SNAPSHOT,
  TOGGLE_CONTACTS_TABLE,
  GET_RAW_COLUMNS_SUCCESS,
  EDIT_SEARCH_PHRASE_ACTION,
  SET_MASSIVE_OPTION_ACTION,
  TOGGLE_TAG_EDITOR_ACTION,
  CLEAR_PAGE_OFFSET_ACTION,
  SET_PAGE_OFFSET_ACTION
} from './../contacts/contacts.actions';
import * as moment from 'moment';

export const initialState: ContactsState = {
  eventsOption: false,
  massiveActions: false,
  excludedContacts: [],
  items: {
    total: 1,
    data: [
      {
        events_count: 0,
        NATIVE_CLIENT_PHONE_NUMBER: [
          {
            blank: false,
            eea: false,
            id: null,
            initial: false,
            isoCountry: 'pl',
            label: '+MOCKNUMBER',
            msisdn: '+MOCKNUMBER',
            notBlank: true,
            optionalIsoCountry: { present: true },
            present: true,
            source: null
          }
        ],
        NATIVE_EVENT_DATE: '2019-02-12T11:24:55.959Z',
        NATIVE_SURNAME: null,
        NATIVE_EVENT_TYPE: 'ImportContactEvent',
        NATIVE_CREATOR_LOGIN: 'lukasz.barbuzinski@crazycall.com',
        NATIVE_AGENT_PHONE_NUMBER: null,
        NATIVE_EVENT_STATUS_INFO: null,
        NATIVE_EMAIL: null,
        NATIVE_NAME: null,
        NATIVE_COMPANY: null,
        NATIVE_RECORD_ID: 80,
        NATIVE_CALL_LENGTH: null,
        info: 'dodatkowe_info',
        NATIVE_TAGS: ['tag111', 'tag222']
      }
    ]
  },
  columns: [
    { type: 'NATIVE', key: 'RECORD_ID', name: 'iRecord Name', frozenLeft: false, translation: 'TiRecord Name' },
    { type: 'NATIVE', key: 'EVENT_DATE', name: 'iEvent Date', frozenLeft: false, translation: 'TiEvent Date' },
    { type: 'NATIVE', key: 'EVENT_TYPE', name: 'iEvent Type', frozenLeft: false, translation: 'TiEvent Type' },
    { type: 'NATIVE', key: 'CREATOR_LOGIN', name: 'iCreator Login', frozenLeft: false, translation: 'TiCreator Login' },
    {
      type: 'NATIVE',
      key: 'CLIENT_PHONE_NUMBER',
      name: 'iClient Phone Number',
      frozenLeft: true,
      translation: 'TiClient Phone Number'
    },
    {
      type: 'NATIVE',
      key: 'AGENT_PHONE_NUMBER',
      name: 'iAgent Phone Number',
      frozenLeft: false,
      translation: 'TiAgent Phone Number'
    },
    {
      type: 'NATIVE',
      key: 'EVENT_STATUS_INFO',
      name: 'iEvent Status Info',
      frozenLeft: false,
      translation: 'TiEvent Status Info'
    },
    { type: 'NATIVE', key: 'CALL_LENGTH', name: 'iCall Length', frozenLeft: false, translation: 'TiCall Length' },
    { type: 'NATIVE', key: 'NAME', name: 'iName', frozenLeft: false, translation: 'TiName' },
    { type: 'NATIVE', key: 'SURNAME', name: 'iSurname', frozenLeft: false, translation: 'TiSurname' },
    { type: 'NATIVE', key: 'COMPANY', name: 'iCompany', frozenLeft: false, translation: 'TiCompany' },
    { type: 'NATIVE', key: 'EMAIL', name: 'iEmail', frozenLeft: false, translation: 'TiEmail' },
    { type: 'NATIVE', key: 'hurtownia', name: 'iHurtownia', frozenLeft: false, translation: 'iHurtownia' },
    { type: 'NATIVE', key: 'TAGS', name: 'Tags', frozenLeft: false, translation: 'Tags' },
    { type: 'NATIVE', key: 'info', name: 'iInfo', frozenLeft: false, translation: 'iInfo' }
  ],
  rawColumns: [
    { type: 'NATIVE', key: 'RECORD_ID', name: 'iRecord Name', frozenLeft: false, translation: 'TiRecord Name' },
    { type: 'NATIVE', key: 'EVENT_DATE', name: 'iEvent Date', frozenLeft: false, translation: 'TiEvent Date' },
    { type: 'NATIVE', key: 'EVENT_TYPE', name: 'iEvent Type', frozenLeft: false, translation: 'TiEvent Type' },
    { type: 'NATIVE', key: 'CREATOR_LOGIN', name: 'iCreator Login', frozenLeft: false, translation: 'TiCreator Login' },
    {
      type: 'NATIVE',
      key: 'CLIENT_PHONE_NUMBER',
      name: 'iClient Phone Number',
      frozenLeft: true,
      translation: 'TiClient Phone Number'
    },
    {
      type: 'NATIVE',
      key: 'AGENT_PHONE_NUMBER',
      name: 'iAgent Phone Number',
      frozenLeft: false,
      translation: 'TiAgent Phone Number'
    },
    {
      type: 'NATIVE',
      key: 'EVENT_STATUS_INFO',
      name: 'iEvent Status Info',
      frozenLeft: false,
      translation: 'TiEvent Status Info'
    },
    { type: 'NATIVE', key: 'CALL_LENGTH', name: 'iCall Length', frozenLeft: false, translation: 'TiCall Length' },
    { type: 'NATIVE', key: 'NAME', name: 'iName', frozenLeft: false, translation: 'TiName' },
    { type: 'NATIVE', key: 'SURNAME', name: 'iSurname', frozenLeft: false, translation: 'TiSurname' },
    { type: 'NATIVE', key: 'COMPANY', name: 'iCompany', frozenLeft: false, translation: 'TiCompany' },
    { type: 'NATIVE', key: 'EMAIL', name: 'iEmail', frozenLeft: false, translation: 'TiEmail' },
    { type: 'NATIVE', key: 'hurtownia', name: 'iHurtownia', frozenLeft: false, translation: 'iHurtownia' },
    { type: 'NATIVE', key: 'TAGS', name: 'Tags', frozenLeft: false, translation: 'Tags' },
    { type: 'NATIVE', key: 'info', name: 'iInfo', frozenLeft: false, translation: 'iInfo' }
  ],
  expandedId: null,
  expandedList: [],
  page: {
    pagination: {
      limit: 10,
      offset: 0,
      size: 0,
      totalElements: 0,
      sortBy: null,
      order: null
    },
    filter: {
      dateFrom: moment()
        .subtract(7, 'day')
        .toISOString(),
      dateTo: moment().endOf('day').add(moment().utcOffset() / 60, 'hours'),
      contactId: null
    }
  },
  filterTags: {},
  tempFilterTags: {},
  editedFilters: [],
  tempEditedFilters: [],
  openedTagGroupTooltips: [],
  editingFilterSnapshot: undefined,
  openedFilter: undefined
};

export function contactsReducer(state: ContactsState = initialState, action: ContactsAction): ContactsState {
  if (!state.page) {
    state = initialState;
  }

  switch (action.type) {
    case GET_COLUMNS_SUCCESS:
      return {
        ...state,
        columns: action.payload.dataCol
      };
    case GET_RAW_COLUMNS_SUCCESS:
      return {
        ...state,
        rawColumns: action.payload
      };
    case GET_CONTACTS_SUCCESS:
      const snapshotUpdated = {
        tempFilterTags: { ...state.filterTags },
        editedFiltersItems: { ...state.editedFiltersItems },
        tempPage: action.payload.page,
        openedFilter: null,
        tempEditedFilters: [...state.editedFilters],
        editedFilters: [...state.editedFilters],
        massiveActions: state.massiveActions
      };

      return {
        ...state,
        items: action.payload.data.items,
        page: action.payload.page,
        tempPage: action.payload.page,
        editingFilterSnapshot: snapshotUpdated,
        massiveActions: state.massiveActions
      };
    case GET_EVENTS:
      return {
        ...state,
        expandedId: action.payload.filter.contactId
      };
    case GET_EVENTS_SUCCESS:
      const contact = state.items.data.find(row => row.NATIVE_RECORD_ID === state.expandedId);
      const updatedContact = {
        ...contact,
        events: action.payload.items.data,
        expanded: true
      };
      const rowsUpdated = state.items.data.map((row: Contact) => {
        if (row.NATIVE_RECORD_ID === state.expandedId) {
          row = updatedContact;
        }

        return row;
      });
      const items = state.items;
      const itemsUpdated = {
        ...items,
        data: rowsUpdated
      };

      return {
        ...state,
        items: itemsUpdated
      };
    case HIDE_EVENTS:
      const hiddenRow = {
        ...action.payload,
        expanded: false
      };
      const rowsEdited = state.items.data.map((row: Contact) => {
        if (row.NATIVE_RECORD_ID === hiddenRow.NATIVE_RECORD_ID) {
          row = hiddenRow;
        }

        return row;
      });
      const currentItems = state.items;
      const itemsEdited = {
        ...currentItems,
        data: rowsEdited
      };

      return {
        ...state,
        items: itemsEdited,
        expandedId: null
      };
    case UPDATE_COLUMNS:
      return {
        ...state,
        columns: action.payload
      };

    case SET_DATE_RANGE:
      let tempRangeFilters;
      if (state.tempPage && state.tempPage.filter) {
        tempRangeFilters = state.tempPage.filter;
      } else {
        tempRangeFilters = state.page.filter;
      }

      const updatedRangeFilter = {
        ...tempRangeFilters,
        dateFrom: action.payload.dateFrom,
        dateTo: action.payload.dateTo
      };
      const currentTempPage = state.tempPage;

      const updatedTempFilters = {
        ...currentTempPage,
        filter: updatedRangeFilter,
        pagination: state.page.pagination
      };
      return {
        ...state,
        tempPage: updatedTempFilters
      };

    case CLEAR_FILTER:
      const newEditedFilters = [];
      const currentPage = { ...state.page };
      const currentFilterTags = { ...state.filterTags };
      Object.keys(currentFilterTags).forEach(key => {
        if (currentFilterTags[key] !== null) {
          newEditedFilters.push(key);
        }
      });

      return {
        ...state,
        tempPage: currentPage,
        tempFilterTags: currentFilterTags,
        openedFilter: null,
        editedFilters: newEditedFilters
      };

    case UPDATE_TEMP_TAG:
      const updatedTagGroupName = action.payload.source;
      const updatedTagsGroup = action.payload.tags;
      const existingTempTags = state.tempFilterTags;

      const updatedTempTags = {
        ...existingTempTags,
        [updatedTagGroupName]: updatedTagsGroup
      };

      return {
        ...state,
        tempFilterTags: updatedTempTags
      };

    case ADD_TAG:
      const addedTagGroupName = action.payload.source;
      const tempTags = state.tempFilterTags ? state.tempFilterTags : {};
      let editedTempTagGroup = [];

      const currentTempTagGroup = tempTags && tempTags[addedTagGroupName] ? tempTags[addedTagGroupName] : [];

      if (currentTempTagGroup.filter(item => item.name === action.payload.name).length) {
        editedTempTagGroup = currentTempTagGroup;
      } else {
        currentTempTagGroup.push(action.payload);
        editedTempTagGroup = currentTempTagGroup;
      }

      const editedTempTags = {
        ...tempTags,
        [addedTagGroupName]: editedTempTagGroup
      };

      return {
        ...state,
        tempFilterTags: editedTempTags
      };

    case REMOVE_TAG:
      const temporaryTags = state.tempFilterTags ? state.tempFilterTags : state.filterTags;
      const removedTagGroupName = action.payload.source;

      if (temporaryTags && temporaryTags[removedTagGroupName]) {
        const editedTemporaryTagGroup = temporaryTags[removedTagGroupName].filter(
          (tag: FilterTag) => tag.name !== action.payload.name
        );
        const editedTemporaryTags = {
          ...temporaryTags,
          [removedTagGroupName]: editedTemporaryTagGroup.length ? editedTemporaryTagGroup : null
        };

        return {
          ...state,
          tempFilterTags: editedTemporaryTags
        };
      } else {
        return state;
      }

    case SET_FILTER_TAGS:
      const newFilterTags = state.tempFilterTags;
      return {
        ...state,
        filterTags: newFilterTags
      };

    case GET_FILTER_ITEMS_SUCCESS:
      const filtersItems = action.payload.list;
      const filterItemType = action.payload.filterName;
      const currentEditedFilterItems = state.editedFiltersItems;
      const updatedEditedFilterItems = {
        ...currentEditedFilterItems,
        [filterItemType]: filtersItems
      };
      return {
        ...state,
        editedFiltersItems: updatedEditedFilterItems,
        openedFilter: filterItemType
      };

    case SET_FILTER_ITEMS_OPENED:
      return {
        ...state,
        openedFilter: action.payload
      };

    case SET_FILTERING_BY_ITEM:
      const openedFilterKey = action.payload.filter;
      let currentEditedFilters;
      let egsistingTempPage;
      if (state.tempPage && state.tempPage.filter) {
        egsistingTempPage = state.tempPage;
        currentEditedFilters = state.tempPage.filter;
      } else {
        egsistingTempPage = state.page;
        currentEditedFilters = state.page.filter;
      }

      const updatedEditedFilters = {
        ...currentEditedFilters,
        [openedFilterKey]: action.payload.collection
      };

      const updatedTempPage = {
        ...egsistingTempPage,
        filter: updatedEditedFilters
      };
      return {
        ...state,
        tempPage: updatedTempPage
      };

    case UPDATE_TEMP_PAGE_WITH_ITEMS:

      let lastEditedFiltersItemsNames;
      const lastOpenedFilter = action.payload;
      const currentEditedFiltersItems = { ...state.editedFiltersItems };

      if (lastOpenedFilter === 'callLengths') {
        lastEditedFiltersItemsNames = currentEditedFiltersItems[lastOpenedFilter].map(item => item.range);
      } else if (lastOpenedFilter === 'clientPhoneNumbers') {
        lastEditedFiltersItemsNames = currentEditedFiltersItems[lastOpenedFilter].map(item => item.name);
      } else {
        lastEditedFiltersItemsNames = currentEditedFiltersItems[lastOpenedFilter]
          .filter(el => el.isFilter === true)
          .map(item => item.name);
      }

      const temporaryPage = state.tempPage ? { ...state.tempPage } : { ...state.page };

      const tempPageFilter = temporaryPage.filter;
      const newUpdatedTempFilter = {
        ...tempPageFilter,
        [lastOpenedFilter]: lastEditedFiltersItemsNames.length ? lastEditedFiltersItemsNames : null
      };
      const updatedTemporaryPage = {
        ...temporaryPage,
        filter: newUpdatedTempFilter
      };

      return {
        ...state,
        tempPage: updatedTemporaryPage,
      };

    case UPDATE_TEMP_EDITED_FILTERS_LIST:
      return {
        ...state,
        tempEditedFilters: action.payload
      };

    case UPDATE_EDITED_FILTERS_LIST:
      return {
        ...state,
        editedFilters: state.tempEditedFilters
      };

    case CLEAR_EDITED_FILTERS_LIST:
      return {
        ...state,
        editedFilters: null
      };

    case TAKE_EDITING_FILTER_SNAPSHOT:
      const editedFiltersShot = state.editedFilters ? [...state.editedFilters] : [];
      const tempEditedFiltersShot = state.tempEditedFilters ? [...state.tempEditedFilters] : editedFiltersShot;
      const tempEditedFiltersItemsShot = state.editedFiltersItems ? { ...state.editedFiltersItems } : {};

      const snapshot = {
        tempFilterTags: state.tempFilterTags ? { ...state.tempFilterTags } : { ...state.filterTags },
        editedFiltersItems: tempEditedFiltersItemsShot ? tempEditedFiltersItemsShot : {},
        tempPage: state.tempPage ? { ...state.tempPage } : { ...state.page },
        openedFilter: state.openedFilter,
        tempEditedFilters:
          tempEditedFiltersItemsShot && tempEditedFiltersItemsShot[state.openedFilter]
            ? tempEditedFiltersShot
            : tempEditedFiltersShot
              ? tempEditedFiltersShot.filter(filter => filter !== state.openedFilter)
              : [...state.editedFilters],
        editedFilters: editedFiltersShot
      };

      return {
        ...state,
        editingFilterSnapshot: snapshot
      };

    case REVERT_EDITED_FILTER_CHANGES:

      const revertSnapshot = { ...state.editingFilterSnapshot };
      const snapshotTempFilterTags = revertSnapshot.tempFilterTags;
      const snapshotEditedFiltersItems = revertSnapshot.editedFiltersItems;
      const snapshotEditedFilters = revertSnapshot.editedFilters;
      const snapshotTempEditedFilters = revertSnapshot.tempEditedFilters;
      const snapshotTempPage = revertSnapshot.tempPage;
      const snapshotCleared = {
        tempFilterTags: { ...state.filterTags },
        editedFiltersItems: { ...state.editedFiltersItems },
        tempPage: { ...state.page },
        openedFilter: null,
        tempEditedFilters: [...state.editedFilters],
        editedFilters: [...state.editedFilters]
      };
      return {
        ...state,
        tempFilterTags: snapshotTempFilterTags ? snapshotTempFilterTags : { ...state.filterTags },
        editedFiltersItems: snapshotEditedFiltersItems,
        tempPage: snapshotTempPage,
        tempEditedFilters: snapshotTempEditedFilters,
        editedFilters: snapshotEditedFilters,
        editingFilterSnapshot: snapshotCleared,
        openedFilter: null
      };

    case OPEN_TOOLTIP_TAG_GROUP:
      const tagGroupTooltips = state.openedTagGroupTooltips ? state.openedTagGroupTooltips : [];
      const newTagGroupTooltips = [...tagGroupTooltips, action.payload];

      return {
        ...state,
        openedTagGroupTooltips: newTagGroupTooltips
      };

    case CLOSE_TOOLTIP_TAG_GROUP:
      const openedTagGroupTooltips = state.openedTagGroupTooltips;
      const filteredTagGroupTooltips = openedTagGroupTooltips.filter(el => el !== action.payload);

      return {
        ...state,
        openedTagGroupTooltips: filteredTagGroupTooltips
      };

    case CLEAR_TOOLTIP_TAG_GROUP:
      return {
        ...state,
        openedTagGroupTooltips: []
      };

    case SAVE_CALL_RANGE_FILTER_FORM:
      return {
        ...state,
        callLengthForm: action.payload
      };

    case UPDATE_TEMP_FILTER_MAXDATA:
      const beforeEditDataTempPage = state.tempPage ? state.tempPage : state.page;
      const beforeTempPageFilter = beforeEditDataTempPage.filter;

      const correctedTempPageFilter = {
        ...beforeTempPageFilter,
        dateTo: action.payload
      };
      const correctedTempPage = {
        ...beforeEditDataTempPage,
        filter: correctedTempPageFilter
      };

      return {
        ...state,
        tempPage: correctedTempPage
      };

    case RESET_STATE:
      return {
        ...initialState
      };

    case UPDATE_EXPANDED_LIST:
      return {
        ...state,
        expandedList: action.payload
      };

    case SET_CALL_FINISH_TYPE_FILTER:
      const beforeFinishTypeTempPage = { ...state.tempPage };
      const beforeFinishTypeTempPageFilter = beforeFinishTypeTempPage.filter;
      const finishTypeFilter = {
        ...beforeFinishTypeTempPageFilter,
        callFinishType: action.payload
      };

      const finishTypeTempPage = {
        ...beforeFinishTypeTempPage,
        filter: finishTypeFilter
      };

      return {
        ...state,
        tempPage: finishTypeTempPage
      };

    case REMOVE_CALL_FINISH_TYPE_FILTER:
      const beforeDeletingFinishTypeTempPage = { ...state.tempPage };
      const beforeDeletingFinishTypeTempPageFilter = beforeDeletingFinishTypeTempPage.filter;

      delete beforeDeletingFinishTypeTempPageFilter[action.payload];
      const deletedFinishTypeFilter = {
        ...beforeDeletingFinishTypeTempPageFilter
      };

      const deletedFinishTypeTempPage = {
        ...beforeDeletingFinishTypeTempPage,
        filter: deletedFinishTypeFilter
      };

      return {
        ...state,
        tempPage: deletedFinishTypeTempPage
      };

    case TAKE_CALL_FINISH_TYPE_SNAPSHOT:
      const snapshotedTempPage = { ...state.tempPage };
      const snapshotedCallFinishType = snapshotedTempPage.filter.callFinishType;

      if (snapshotedCallFinishType) {
        return {
          ...state,
          callFinishTypeSnapshot: snapshotedCallFinishType
        };
      } else {
        return state;
      }

    case REVERT_CALL_FINISH_TYPE_SNAPSHOT:
      const currentCallFinisTypeSnapshot = state.callFinishTypeSnapshot;
      const currentTempPageToRevert = { ...state.tempPage };
      const currentTempPageFilterToRevert = currentTempPageToRevert.filter;

      if (currentCallFinisTypeSnapshot) {
        const revertedTempPageFilter = {
          ...currentTempPageFilterToRevert,
          callFinishType: currentCallFinisTypeSnapshot
        };

        const revertedTempPage = {
          ...currentTempPageToRevert,
          filter: revertedTempPageFilter
        };

        const revertModifiedState = {
          ...state,
          tempPage: revertedTempPage
        };

        delete revertModifiedState.callFinishTypeSnapshot;

        return revertModifiedState;
      } else {
        const stateToRevertCallFinishType = { ...state };
        delete stateToRevertCallFinishType.tempPage.filter.callFinishType;

        return stateToRevertCallFinishType;
      }

    case TOGGLE_CONTACTS_TABLE:
      const tableOptionPage = state.tempPage ? { ...state.tempPage } : { ...state.page };
      const tableOptionPagePagination = { ...tableOptionPage.pagination, offset: 0 };
      const correctedOptionPage = { ...tableOptionPage, pagination: tableOptionPagePagination };

      return {
        ...state,
        eventsOption: action.payload,
        tempPage: correctedOptionPage
      };

    case EDIT_SEARCH_PHRASE_ACTION:
      const previousTempPage = state.tempPage ? { ...state.tempPage } : { ...state.page };
      const previousTempPageFilter = { ...previousTempPage.filter };
      const searchPhraseFilter = {
        ...previousTempPageFilter,
        fullTextSearchPhrase: action.payload
      };

      const searchPhraseTypeTempPage = {
        ...previousTempPage,
        filter: searchPhraseFilter
      };

      return {
        ...state,
        tempPage: searchPhraseTypeTempPage
      };

    case SET_MASSIVE_OPTION_ACTION:
      return {
        ...state,
        massiveActions: action.payload
      };

    case CLEAR_PAGE_OFFSET_ACTION:
      const previousOffsetPage = state.tempPage ? { ...state.tempPage } : { ...state.page };
      const newOffsetPagination = { ...previousOffsetPage.pagination, offset: action.payload };

      const newOffsetTempPage = { ...previousOffsetPage, pagination: newOffsetPagination };
      return {
        ...state,
        tempPage: newOffsetTempPage
      };

    case SET_PAGE_OFFSET_ACTION:
      const existingOffsetPage = state.tempPage ? { ...state.tempPage } : { ...state.page };
      const contactsOffsetPagination = { ...existingOffsetPage.pagination, offset: action.payload };

      const improvedOffsetTempPage = { ...existingOffsetPage, pagination: contactsOffsetPagination };
      return {
        ...state,
        tempPage: improvedOffsetTempPage
      };

    case TOGGLE_TAG_EDITOR_ACTION:
      return {
        ...state,
        tagEditorOpened: action.payload
      };

    default:
      return state;
  }
}

const getContactsRows = (contactState: ContactsState): Contact[] => contactState.items.data;
const getContactsCols = (contactState: ContactsState): Column[] => contactState.columns;
const getRawContactsColumns = (contactState: ContactsState): Column[] => contactState.rawColumns;
const getContactsTotal = (contactState: ContactsState): number => contactState.items.total;
const getContactsPage = (contactState: ContactsState): Page => contactState.page;
const getTempPage = (contactState: ContactsState): Page => contactState.tempPage;
const getCampaigns = (contactState: ContactsState): Campaign[] => contactState.campaigns;
const getTags = (contactState: ContactsState): FilterTagGroup => contactState.filterTags;
const getTempTags = (contactState: ContactsState): FilterTagGroup => contactState.tempFilterTags;
const getEditedFilters = (contactState: ContactsState): string[] => contactState.editedFilters;
const getTempEditedFilters = (contactState: ContactsState): string[] => contactState.tempEditedFilters;
const getEditedFilterItems = (contactState: ContactsState): FiltersEditedItems => contactState.editedFiltersItems;
const getOpenedFilterItem = (contactState: ContactsState): string => contactState.openedFilter;
const getExpandedList = (contactState: ContactsState): number[] => contactState.expandedList;
const getOpenedTagGroupTooltips = (contactState: ContactsState): string[] => contactState.openedTagGroupTooltips;
const getCallLengthForm = (contactState: ContactsState): any => contactState.callLengthForm;
const getSnapshot = (contactState: ContactsState): any => contactState.editingFilterSnapshot;
const getEventsOption = (contactState: ContactsState): boolean => contactState.eventsOption;
const getMassiveAction = (contactState: ContactsState): boolean => contactState.massiveActions;
const getExcludedContacts = (contactState: ContactsState): number[] => contactState.excludedContacts;
const getTagEditorOpened = (contactState: ContactsState): boolean => contactState.tagEditorOpened;
const getExpandedId = (contactState: ContactsState): number => contactState.expandedId;

export const getMainContactsSelector = (state): ContactsState => state.contacts;

export const getContactsRowsSelector = createSelector(getMainContactsSelector, getContactsRows);
export const getContactsColsSelector = createSelector(getMainContactsSelector, getContactsCols);
export const getRawContactsColumnsSelector = createSelector(getMainContactsSelector, getRawContactsColumns);
export const getContactsTotalSelector = createSelector(getMainContactsSelector, getContactsTotal);
export const getContactsPageSelector = createSelector(getMainContactsSelector, getContactsPage);
export const getTempPageSelector = createSelector(getMainContactsSelector, getTempPage);
export const getCampaignsSelector = createSelector(getMainContactsSelector, getCampaigns);
export const getTagsSelector = createSelector(getMainContactsSelector, getTags);
export const getTempTagsSelector = createSelector(getMainContactsSelector, getTempTags);
export const getEditedFiltersSelector = createSelector(getMainContactsSelector, getEditedFilters);
export const getTempEditedFiltersSelector = createSelector(getMainContactsSelector, getTempEditedFilters);
export const getEditedFilterItemsSelector = createSelector(getMainContactsSelector, getEditedFilterItems);
export const getOpenedFilterItemSelector = createSelector(getMainContactsSelector, getOpenedFilterItem);
export const getExpandedListSelector = createSelector(getMainContactsSelector, getExpandedList);
export const getOpenedTagGroupTooltipsSelector = createSelector(getMainContactsSelector, getOpenedTagGroupTooltips);
export const getCallLengthFormSelector = createSelector(getMainContactsSelector, getCallLengthForm);
export const getSnapshotSelector = createSelector(getMainContactsSelector, getSnapshot);
export const getEventsOptionSelector = createSelector(getMainContactsSelector, getEventsOption);
export const getMassiveActionSelector = createSelector(getMainContactsSelector, getMassiveAction);
export const getExcludedContactsSelector = createSelector(getMainContactsSelector, getExcludedContacts);
export const getTagEditorOpenedSelector = createSelector(getMainContactsSelector, getTagEditorOpened);
export const getExpandedIdSelector = createSelector(getMainContactsSelector, getExpandedId);
